import { useEffect } from "react";
import { useSelector } from "react-redux";
import i18n from "./i18n";
import { RootState } from "../../app/store";
import { getCookie, TOKEN_COOKIE } from "../cookies";

const languageMap: Record<number, string> = {
  1: "es",
  2: "en",
  3: "cat",
  4: "pt",
  5: "fr",
  6: "it",
};

export function useSyncLanguage() {
  const isAuthenticated = !!useSelector(
    (state: RootState) => state.auth?.user?.id,
  );
  const userLangId = useSelector(
    (state: RootState) => state.auth?.user?.id_language ?? null,
  );
  const themeLangId = useSelector(
    (state: RootState) => state.admin?.publicationTheme?.id_language_1 ?? null,
  );

  useEffect(() => {
    let targetLng: string | null = null;
    const savedLng = localStorage.getItem("i18nextLng");

    if (isAuthenticated && userLangId !== null) {
      // Con sesión iniciada manda el idioma del perfil (id_language de /me)
      targetLng = languageMap[userLangId] ?? null;
    } else if (!isAuthenticated && getCookie(TOKEN_COOKIE)) {
      // Hay sesión pero /me aún no ha respondido: se espera para no mostrar
      // (ni guardar) el idioma de la revista antes de conocer el del usuario
      return;
    } else if (themeLangId !== null) {
      targetLng = languageMap[themeLangId];
    }

    if (!targetLng && savedLng) {
      targetLng = savedLng;
    }

    if (targetLng && targetLng !== i18n.language) {
      i18n
        .changeLanguage(targetLng)
        .catch((err) => console.error("Error changeLanguage:", err));
    }
  }, [isAuthenticated, userLangId, themeLangId]);
}
